export function dateToISOstring(
  startDate,
  format = "YYYY/MM/DD HH:mm:ss",
  utcTime = false
) {
  if (
    !(format.includes("YYYY") && format.includes("MM") && format.includes("DD"))
  ) {
    format = "YYYY/MM/DD HH:mm:ss";
  }
  try {
    if (utcTime === true) {
      return format
        .replace("YYYY", startDate.getUTCFullYear())
        .replace(
          "MM",
          (startDate.getUTCMonth() + 1).toString().padStart(2, "0")
        )
        .replace("DD", startDate.getUTCDate().toString().padStart(2, "0"))
        .replace("HH", startDate.getUTCHours().toString().padStart(2, "0"))
        .replace("mm", startDate.getUTCMinutes().toString().padStart(2, "0"))
        .replace("ss", startDate.getUTCSeconds().toString().padStart(2, "0"));
    }
    return format
      .replace("YYYY", startDate.getFullYear())
      .replace("MM", (startDate.getMonth() + 1).toString().padStart(2, "0"))
      .replace("DD", startDate.getDate().toString().padStart(2, "0"))
      .replace("HH", startDate.getHours().toString().padStart(2, "0"))
      .replace("mm", startDate.getMinutes().toString().padStart(2, "0"))
      .replace("ss", startDate.getSeconds().toString().padStart(2, "0"));
  } catch {
    return "Invalid Date";
  }
  // return (
  //   startDate.getFullYear() +
  //   "/" +
  //   (startDate.getMonth() + 1).toString().padStart(2, "0") +
  //   "/" +
  //   startDate.getDate().toString().padStart(2, "0") +
  //   " " +
  //   startDate.getHours().toString().padStart(2, "0") +
  //   ":" +
  //   startDate.getMinutes().toString().padStart(2, "0") +
  //   ":" +
  //   startDate.getSeconds().toString().padStart(2, "0")
  // );
}

export function stringToDate(sDate) {
  //format: "dd/mm/yyyy" or "dd/mm/yyyy hh:mm:ss"
  if (sDate && typeof sDate === "string") {
    let result;
    let stringParts = sDate.split(" ");
    let dateParts = stringParts.length > 0 ? stringParts[0] : "";
    let timeParts = stringParts.length > 1 ? stringParts[1] : "";

    if (dateParts !== "") {
      dateParts = dateParts.split("/");
      if (dateParts && dateParts.length > 2) {
        if (timeParts !== "") {
          timeParts = timeParts.split(":");
          result = new Date(
            dateParts[2],
            dateParts[1] - 1,
            dateParts[0],
            timeParts[0],
            timeParts[1],
            timeParts[2]
          );
        } else {
          result = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
        }
      } else {
        result = new Date("");
      }
    } else {
      result = new Date("");
    }
    return result;
  }
  return null;
}

export function getAlarmColorState (alarm) {
  if (alarm) {
    console.log("getColorState", alarm.digitalinputb);
    //(alarm.digitalinputb && alarm.AlarmType.indexOf(alarm.digitalinputb.ident) == 0) ? (alarm.digitalinputb.states && alarm.digitalinputb.states.find(item => item.this.state.toString().toLowerCase() === alarm.AlarmType.replace(alarm.digitalinputb.ident,"").trim()).value==1 ? '#71816D' : '#DA667B'): 'darkorange'
    if (alarm.digitalinputb && alarm.AlarmType.indexOf(alarm.digitalinputb.ident) == 0) {
      if (alarm.digitalinputb.states) {
        const matchingState = alarm.digitalinputb.states.find(item => item.state.toString().toLowerCase() === alarm.AlarmType.replace(alarm.digitalinputb.ident, "").trim().toLowerCase());
        if (matchingState && matchingState.value == 1) {
          return '#71816D';
        } else if (matchingState && matchingState.value == 0) {
          return '#DA667B';
        } else {
          return '#CDD1DE';
        }
      }
    }
  }
  return 'darkorange';
}
